(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Header toggles */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-toggle]');
    if (!t) return;
    const panel = document.getElementById(t.getAttribute('data-toggle'));
    if (!panel) return;
    const open = panel.classList.toggle('is-open');
    t.setAttribute('aria-expanded', String(open));
    if (open) { const input = panel.querySelector('input'); if (input) input.focus(); }
  });

  /* Reveal on scroll */
  const reveals = $$('.reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-visible'));
  }

  /* Cart count */
  const setCount = (n) => $$('[data-cart-count]').forEach((el) => { el.textContent = n > 0 ? n : ''; el.dataset.count = n; });

  /* Quantity steppers */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    const min = parseInt(input.min || '0', 10);
    const next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.qty, 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Product form: variants + AJAX add */
  $$('[data-product-form]').forEach((form) => {
    const dataEl = form.querySelector('script[type="application/json"]');
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const idInput = form.querySelector('input[name="id"]');
    const button = form.querySelector('[type="submit"]');
    const label = button.querySelector('span') || button;
    const section = form.closest('[data-section]');
    const priceEl = section && section.querySelector('[data-price]');
    const money = (cents) => {
      const fmt = form.dataset.moneyFormat || '${{amount}}';
      const amount = (cents / 100).toFixed(2);
      return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    };

    const update = () => {
      const chosen = $$('fieldset.option', form).map((fs) => { const c = fs.querySelector('input:checked'); return c ? c.value : null; });
      const v = variants.find((x) => x.options.every((o, i) => o === chosen[i]));
      if (!v) {
        button.disabled = true; label.textContent = button.dataset.unavailable; return;
      }
      if (idInput.value !== String(v.id)) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      button.disabled = !v.available;
      label.textContent = v.available ? button.dataset.add : button.dataset.soldout;
      if (priceEl) {
        const onSale = v.compare_at_price && v.compare_at_price > v.price;
        priceEl.classList.toggle('price--on-sale', !!onSale);
        priceEl.innerHTML = '<span class="price__current">' + money(v.price) + '</span>' + (onSale ? '<s class="price__compare">' + money(v.compare_at_price) + '</s>' : '');
      }
      if (v.featured_media && section) {
        const thumb = section.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (thumb) thumb.click();
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    };
    form.addEventListener('change', (e) => { if (e.target.closest('fieldset.option')) update(); });

    form.addEventListener('submit', async (e) => {
      // Bundle apps (e.g. Kaching Bundles) handle their own add-to-cart; don't double-add
      if (e.defaultPrevented || (section && section.querySelector('kaching-bundle, [class*="kaching"]'))) return;
      e.preventDefault();
      button.disabled = true;
      const original = label.textContent;
      label.textContent = button.dataset.adding;
      try {
        const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
        if (!res.ok) throw new Error((await res.json()).description || 'Error');
        const cart = await (await fetch(root + 'cart.js')).json();
        setCount(cart.item_count);
        label.textContent = button.dataset.added;
        setTimeout(() => { label.textContent = original; button.disabled = false; }, 1600);
      } catch (err) {
        label.textContent = original; button.disabled = false;
        const msg = form.querySelector('[data-form-error]');
        if (msg) { msg.textContent = err.message; msg.hidden = false; }
      }
    });
  });

  /* Product gallery thumbs */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-thumb]');
    if (!b) return;
    const gallery = b.closest('[data-gallery]');
    const main = gallery.querySelector('.js-main-image');
    main.src = b.dataset.src; main.srcset = ''; main.alt = b.dataset.alt || '';
    $$('[data-thumb]', gallery).forEach((x) => x.setAttribute('aria-current', String(x === b)));
  });

  /* Cart page: auto-submit qty changes */
  const cartForm = $('[data-cart-form]');
  if (cartForm) {
    let t;
    cartForm.addEventListener('change', (e) => {
      if (e.target.name !== 'updates[]') return;
      clearTimeout(t); t = setTimeout(() => cartForm.submit(), 400);
    });
  }

  /* Collection sort */
  const sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value); url.searchParams.delete('page');
    window.location.href = url.toString();
  });
})();
